<template>
  <div class="search__pagination" v-if="numPages > 1">
    <nav aria-label="Search Pagination" class="search__pagination-nav">
      <ul class="search__pagination-flex">
        <li v-if="pageNum != 1" class="search__pagination__prev-link">
          <a
            :href="`?page=${pageNum - 1}`"
            @click="goToPage($event, pageNum - 1)"
          >
            Back
          </a>
        </li>
        <li v-for="(page, index) in numPages" :key="index">
          <a
            :href="`?page=${index + 1}`"
            :class="{ active: index + 1 == pageNum }"
            @click="goToPage($event, index + 1)"
            :aria-label="
              index + 1 == pageNum ? 'Current Page' : `Go to page ${index + 1}`
            "
          >
            {{ index + 1 }}
          </a>
        </li>
        <li v-if="pageNum != numPages" class="search__pagination__next-link">
          <a
            :href="`?page=${pageNum + 1}`"
            @click="goToPage($event, pageNum + 1)"
          >
            Next
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNum: 1,
      numPages: 0,
      params: Array,
      currentURL: Array,
    }
  },
  props: {
    results: {
      type: Number,
    },
    resultsPerPage: {
      type: Number,
      default: 7,
    },
  },
  methods: {
    goToPage(event, pageDestination) {
      event.preventDefault()
      const newLink = this.currentUrl
      newLink.searchParams.set('page', pageDestination)
      window.location.href = newLink
    },
  },
  computed: {
    getNewUrl(pageDestination) {
      return this.currentUrl.searchParams.set('page', pageDestination)
    },
  },
  mounted() {
    // set the URL so that it can be used to link
    this.currentUrl = new URL(window.location)

    let uri = window.location.search.substring(1)
    this.params = new URLSearchParams(uri)

    if (this.params.get('page')) {
      this.pageNum = Number(this.params.get('page'))
    }

    if (this.results) {
      this.numPages = Math.floor(this.results / this.resultsPerPage)
      if (this.results % this.resultsPerPage) this.numPages = this.numPages + 1
    }
  },
}
</script>
